import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

// Persistent Anonymous Visitor Tracking
try {
  let visitorId = localStorage.getItem('bv_visitor_id');
  if (!visitorId) {
    visitorId = 'v_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    localStorage.setItem('bv_visitor_id', visitorId);
  }

  fetch('/api/visit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      visitorId,
      userAgent: navigator.userAgent,
      page: window.location.pathname
    })
  }).catch(() => {});
} catch (e) {}

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

